import CreditCardsFullPaginatedDataReducer, {
  Actions as CreditCardsFullPaginatedDataActions,
  CreditCardsFullPaginatedDataState,
  initialState as initialCreditCardsFullPaginatedDataState,
} from 'src/redux/creditCardsFullPaginatedData.reducer'
import UsersFullPaginatedDataReducer, {
  Actions as UsersFullPaginatedDataActions,
  initialState as initialUsersFullPaginatedDataState,
  UsersFullPaginatedDataState,
} from 'src/redux/usersFullPaginatedData.reducer'

export interface BudgetsState {
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataState
  usersFullPaginatedData: UsersFullPaginatedDataState
}

export const initialState: BudgetsState = {
  creditCardsFullPaginatedData: initialCreditCardsFullPaginatedDataState,
  usersFullPaginatedData: initialUsersFullPaginatedDataState,
}

export type Actions =
  | CreditCardsFullPaginatedDataActions
  | UsersFullPaginatedDataActions

const BudgetsReducer = (
  state = initialState,
  action: Actions,
): BudgetsState => ({
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataReducer(
    state.creditCardsFullPaginatedData,
    action as CreditCardsFullPaginatedDataActions,
  ),
  usersFullPaginatedData: UsersFullPaginatedDataReducer(
    state.usersFullPaginatedData,
    action as UsersFullPaginatedDataActions,
  ),
})

export default BudgetsReducer
